import React from "react";
import { useUnifiedService } from "../../utilities/contexts/UnifiedServiceContext";
import { ServiceStep } from "../../utilities/types/unified-services";
import { useAutoScrollToTop } from "../../utilities/hooks/useScrollToTop";
import { getServiceStepFlow } from "../../utilities/helpers/serviceStepMapper";
import UnifiedStepIndicator from "./UnifiedStepIndicator";
import UnifiedStepNavigation from "./UnifiedStepNavigation";

import UnifiedGuideStep from "./steps/UnifiedGuideStep";
import UnifiedUploadStep from "./steps/UnifiedUploadStep";
import UnifiedFaceBlurStep from "./steps/UnifiedFaceBlurStep";
import UnifiedHeightInputStep from "./steps/UnifiedHeightInputStep";
import UnifiedProcessingStep from "./steps/UnifiedProcessingStep";
import UnifiedResultsStep from "./steps/UnifiedResultsStep";

const UnifiedService: React.FC = () => {
  const { serviceInterface, serviceConfig } = useUnifiedService();
  const { currentStep } = serviceInterface;

  useAutoScrollToTop(currentStep);

  const stepFlow = getServiceStepFlow(serviceConfig);

  const renderCurrentStep = () => {
    if (!stepFlow.isValidStep(currentStep)) {
      return <UnifiedGuideStep />;
    }

    switch (currentStep) {
      case ServiceStep.GUIDE:
        return <UnifiedGuideStep />;
      case ServiceStep.UPLOAD:
        return <UnifiedUploadStep />;
      case ServiceStep.FACE_BLUR:
        if (serviceConfig.processing.requiresFaceBlur) {
          return <UnifiedFaceBlurStep />;
        }

        return <UnifiedProcessingStep />;
      case ServiceStep.HEIGHT_INPUT:
        if (serviceConfig.configuration?.requiresHeight) {
          return <UnifiedHeightInputStep />;
        }

        return <UnifiedProcessingStep />;
      case ServiceStep.PROCESSING:
        return <UnifiedProcessingStep />;
      case ServiceStep.RESULTS:
        return <UnifiedResultsStep />;
      default:
        return <UnifiedGuideStep />;
    }
  };

  return (
    <div className="min-h-dvh" style={{ backgroundColor: "#f5f5f5" }}>
      <div className="p-2 mx-auto md:p-4">
        <div className="w-full px-2 py-4 mx-auto bg-white lg:p-6 rounded-3xl">
          <UnifiedStepIndicator />
          <div className="min-h-fit">{renderCurrentStep()}</div>
          {currentStep !== ServiceStep.PROCESSING && currentStep !== ServiceStep.RESULTS && currentStep !== ServiceStep.FACE_BLUR && <UnifiedStepNavigation />}
        </div>
      </div>
    </div>
  );
};

export default UnifiedService;
